import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
/**
 * Filters out nodes that are not in the tree or that do not have a label
 */
export var getNodesThatCanBeRendered = function getNodesThatCanBeRendered(tree, children) {
  return children.map(function (childId) {
    return tree[childId];
  }).filter(function (node) {
    return node && node.label;
  }).map(function (node) {
    return node;
  });
};